import React, { Component } from 'react';
import { Button, Select, DatePicker,Modal, Row, Col, Input, Radio, message,Tooltip ,Icon,AutoComplete } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import format from '../../shared/format';
import TableC from '../../basicElement/TableC';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import moment from 'moment';

const yearFormat = 'YYYY';
let year = moment().format(yearFormat);

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;
const TextArea = Input.TextArea;

class Filter extends Component {

    state = {
        maxDate:moment(),
        searchParams: {
            //date:moment().format('YYYY-MM')
        },
        operable:true,
        businessList: [],
        areaList:[],
        diseaseList:[],
    }

    componentDidMount() {
        this.getDate()
        this.queryWithLevelByParams();
        this.loadTypeConfigureList();
    }

    getDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
            const nowT = moment(date).format('YYYY-MM-DD HH:mm');
            const nowM = moment(date).format('YYYY-MM');
            const canMark = ( `${nowM}-28 12:00` < nowT );
            const{searchParams={}}=this.state;
            this.setState({
            searchParams:{
                ...searchParams,
                date:canMark?nowM:moment(nowM).subtract(1, 'M').format('YYYY-MM')
            }
        });
        })
    }

    search = () => {
        const { searchParams } = this.state;
        const params = {
            ...searchParams,
        };

        this.props.search(params);
    }

    export = () => {
        const { searchParams } = this.state;
        const params = {
            ...searchParams,
        };

        this.props.export(params);
    }

    handleDateChange = (date, dateString, key) => {
        const { searchParams } = this.state;
        searchParams[key] = dateString
        this.setState({ searchParams });
    }

    disabledDate = (current) => {
        const { maxDate } = this.state;
        const value = moment(maxDate).valueOf();
        return current && current.valueOf() > value;
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => this.setState({ businessList: res.typeConfigureList || [] }));
    }

    onChange = (searchParams) => {
        this.setState({ searchParams: { ...searchParams }});
    }

    handleChange = (value, key) => {
        let { searchParams } = this.state;
        switch (key) {
            case 'investigation': {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                this.onChange(searchParams);
                break;
            }
            case 'lineOfBusiness':
                searchParams[key] = value;
                searchParams.secondLineName = undefined;
                this.onChange(searchParams);
                break;
            case 'leaderName': {
                const { value: id, text: name } = value;
                searchParams[`${key}Field`] = id;
                searchParams[`${key}`] = name;
                this.onChange(searchParams);
                break;
            }
            case 'investigationAreaId':{
                searchParams[key] = value;
                searchParams.diseaseId = undefined;
                searchParams.diseaseName = undefined;
                this.onChange(searchParams);
                this.loadDiseaseList();
                break;
            }
            case "diseaseId":{
                value?searchParams.diseaseId=value:searchParams.diseaseId = undefined;
                searchParams.diseaseName = undefined;
                this.onChange(searchParams);
                break;
            }
            default:
                searchParams[key] = value;
                this.onChange(searchParams);
        }
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                areaList: res.areaList,
                // levelList: res.levelList,
                // typeList: res.typeList,
                // stageList: res.stageList,
                // testeeTypeList: res.testeeTypeList,
                // contractTypeList: res.contractTypeList,
            });
        })
    }

    loadDiseaseList = (value) => {
        const { searchParams: { investigationAreaId } } = this.state;
        if (investigationAreaId) {
            const options = {
                method: 'POST',
                url: API_URL.common.queryAllDisease,
                data: {
                    keyword: value,
                    investigationAreaId,
                },
                dataType: 'json',
                doneResult: res => {
                    this.setState({ diseaseList: res.data });
                }
            };
            $.sendRequest(options);
        } else {
            this.setState({ diseaseList: [] });
        }
    }

    render() {
        const { 
            searchParams,
            operable,
            businessList,
            areaList,
            diseaseList 
        } = this.state;
        const { 
            date, 
            lineOfBusiness,
            investigationName,
            secondLineName,
            investigationAreaId,
            leaderName,
            reason,
            mainCode,
            diseaseName 
        } = searchParams;
        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        // 执行业务线二级分类
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });
        const secondLineOption = [...secondLineSet].map(d => <Option key={d} title={d}>{d}</Option>);
        //项目领域
        const areaListOption = areaList.map(d => <Option key={String(d.investigationAreaId)} title={d.investigationAreaName}>{d.investigationAreaName}</Option>);
        //疾病
        const diseaseOption = diseaseList.map(d => <Option key={String(d.diseaseId)} showValue={d.diseaseName} title={d.diseaseName}>{d.diseaseName}</Option>);
        //异常原因
        const errorList = [
            { errorReason: "完工百分比≥10%" },
            { errorReason: "当月收入≥20万" },
            { errorReason: "当月收入≤-5万" },
            { errorReason: "项目到达完工结束月" },
            { errorReason: "截至本月末完工%＞100%" },
            { errorReason: "当月完工百分比<-5%" },
        ];
        const errorOption = errorList.map(d => <Option key={d.errorReason}>{d.errorReason}</Option>);
        return (
            <div className="filter-wrap" style={{ padding: 10, background: '#fff' }}>
            <div className="filter-item">
                <label className="filter-label">异常月份</label>
                <MonthPicker
                    format={monthFormat}
                    value={date ? moment(date) : null}
                    onChange={(date, dateString) => this.handleDateChange(date, dateString, 'date')}
                    disabledDate={this.disabledDate}
                    allowClear={false}
                    style={{width: 100, verticalAlign: 'middle'}}
                />
            </div>
            <div className="filter-item">
                <label className="filter-label">项目简称</label>
                <SearchRetrieve
                    keyword="investigationName"
                    style={{ width: 162 }}
                    placeholder="输入名称检索"
                    params={{ limit: 20 }}
                    value={investigationName}
                    url={API_URL.investigation.queryInvestigationByName}
                    config={{ id: "investigationId", name: "investigationName" }}
                    onChange={value => this.handleChange(value, 'investigation')}
                />
            </div>
            <div className="filter-item">
                <div className="filter-label" style={{display:'inline-block'}}>JDE主项目号</div>
                <Input
                    placeholder="请输入"
                    style={{ width: 120 }}
                    value={mainCode}
                    // onKeyPress={this.handleKeyPress}
                    onChange={e => this.handleChange(e.target.value, 'mainCode')}
                />
            </div>
            <div className="filter-item">
                <label className="filter-label">业务线</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 120}}
                    value={lineOfBusiness}
                    onChange={value => this.handleChange(value, 'lineOfBusiness')}
                >
                    {businessOption}
                </Select>
            </div>
            <div className="filter-item">
                <label className="filter-label">执行业务线二级分类</label>
                <Select
                    allowClear={true}
                    filterOption={false}
                    placeholder="请选择"
                    style={{width: 120}}
                    value={secondLineName}
                    disabled={!lineOfBusiness}
                    onChange={value => this.handleChange(value, 'secondLineName')}
                >
                    {secondLineOption}
                </Select>
            </div>
            <div className="filter-item">
                <label htmlFor="" className="filter-label">项目领域</label>
                <Select
                    placeholder="请选择"
                    allowClear={true}
                    value={investigationAreaId}
                    style={{ width: 120 }}
                    onChange={value => this.handleChange(value, 'investigationAreaId')}
                    >
                        {areaListOption}
                </Select>
            </div>
            <div className="filter-item">
                <label htmlFor="" className="filter-label">疾病</label>
                {
                    investigationAreaId ?
                            <AutoComplete
                                onSearch={this.loadDiseaseList}
                                allowClear={true}
                                style={{width: 120}}
                                optionLabelProp="showValue"
                                placeholder="输入名称检索"
                                onChange={value => this.handleChange(value, 'diseaseId')}
                            >
                            {diseaseOption}
                        </AutoComplete>
                        :
                        <Input
                            placeholder="请输入"
                            style={{width: 120}}
                            value={diseaseName}
                            onChange={e => this.handleChange(e.target.value, 'diseaseName')}
                            onKeyPress={this.enterSearch}
                        />
                }
            </div>
            <div className="filter-item">
                <label htmlFor="" className="filter-label">领域leader</label>
                <SearchRetrieve
                    keyword='leaderName'
                    style={{ width: 140 }}
                    placeholder="输入姓名/工号检索"
                    value={leaderName}
                    params={{ limit: 20 }}
                    url={API_URL.user.queryLeaderListForSearch}
                    config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                    onChange={value => this.handleChange(value, 'leaderName')}
                />
            </div>
            <div className="filter-item">
                    <label className="filter-label">异常原因</label>
                    <Select
                        placeholder="请选择"
                        style={{ width: 150 }}
                        value={reason}
                        allowClear
                        onChange={(value) => this.handleChange(value, "reason")}
                    >
                        {errorOption}
                    </Select>
                </div>
            <div className="filter-item">
                <Button type="primary" onClick={this.search}>搜索</Button>
            </div>
            <div className="filter-item">
            <Button type="primary" disabled={!operable} onClick={this.export}>导出</Button>
            </div>
        </div>
        )
    }
}







class RemarkNormalModal extends Component {
    state = {
        visible: false,
        confirmLoading: false,
        enterpriseWorkNameValue:""
    }
   
    show = params => {
        this.setState({
            visible: true,
            reportInfo:{...params},
        });
    };

    hide = () => {
        this.setState({ visible: false,reportInfo:{},remark:"" });
    };

    handleSubmit = () => {
        const {  reportInfo={},remark } = this.state;
        const url =  API_URL.financialAnomalyReport.markInvAbnormal;
        const{investigationAbnormalId}=reportInfo;
        if(!remark){
            message.warning("请填写补充说明");
        }else{
        const options = {
            method: 'POST',
            url,
            data: {
                remark,
                type:"NORMAL",
                investigationAbnormalId
            },
            dataType: 'json',
            doneResult:  res => {
                if (res.success) {
                    message.success(res.success);
                } else if (res.error) {
                    message.error(res.error);
                }
                //this.setState({ visible: false });
                this.hide();
                this.props.reload();
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
        }
    };

    onTextAreaChange = e => {
        this.setState({ remark: e.target.value });
    }

    render() {
        const { visible, confirmLoading, remark, } = this.state;
        return (
            <Modal
                title={"标记为正常项目"}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                disabled={true}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={confirmLoading}
            >
                 <p style={{marginBottom:"15px"}}>请填写补充说明：</p>
                <TextArea placeholder={"请输入（必填）"} value={remark} rows={4} onChange={this.onTextAreaChange}
                 maxLength="255"
                />
            </Modal>
        );
    }
}

class FinancialAnomalyReport extends Component {
    state = {
        data: [],
        loading: false,
        sortParams: {},
        searchParams: {
            //date:moment().format('YYYY-MM')
        },
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        this.getDate()
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.financialAnomalyReport.queryInvAbnormalList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
                queryType:"OWNER",
                type:"ABNORMAL"
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
           const nowT = moment(date).format('YYYY-MM-DD HH:mm');
           const nowM = moment(date).format('YYYY-MM');
           const canMark = ( `${nowM}-28 12:00` < nowT );
           const{searchParams={}}=this.state;
           this.setState({
            nowDate:date,
            searchParams:{
                ...searchParams,
                date:canMark?nowM:moment(nowM).subtract(1, 'M').format('YYYY-MM')
            }
        },()=>{
          this.loadData();
        });
        })
    }

    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination, searchParams: {...params} }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams } = this.state;
        const url = API_URL.financialAnomalyReport.exportInvAbnormalList;
        ExportUtil.export({ ...sortParams, ...searchParams,queryType:"OWNER",type:"ABNORMAL"}, null, url);
    }

    markNormal=(record)=>{
        console.log(record);
        this.remarkNormalModalRef.show(record);
    }

    getColumns = () => {
        const columns = [{
            title: '业务线',
            dataIndex: 'lineOfBusiness',
            key: 'lineOfBusiness',
            fixed: 'left',
            width: 80,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'mainCode',
            key: 'mainCode',
            fixed: 'left',
            width: 120,
        },{
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 100,
        },
        {
            title: '异常原因',
            dataIndex: 'reason',
            key: 'reason',
            width: 150,
        }, {
            title: '项目类型',
            dataIndex: 'investigationGlobalType',
            key: 'investigationGlobalType',
            width: 150,
        },{
            title: '研究产品类型',
            dataIndex: 'investigationMedicineType',
            key: 'investigationMedicineType',
            width: 100,
        },{
            title: '项目分期',
            dataIndex: 'byStageName',
            key: 'byStageName',
            width: 100,
        },{
            title: '项目分类',
            dataIndex: 'typeName',
            key: 'typeName',
            width: 150,
        },{
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 150,
        },{
            title: '计收入确认方式',
            dataIndex: 'contractTypeName',
            key: 'contractTypeName',
            width: 100,
        },{
            title: 'PM工号',
            dataIndex: 'pmCode',
            key: 'pmCode',
            width: 150,
        },{
            title: 'PM姓名',
            dataIndex: 'pm',
            key: 'pm',
            width: 100,
        },{
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 100,
        },{
            title: '项目疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 150,
        },{
            title: '领域leader',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 100,
        },{
            title: 'PML（包含大区总监）',
            dataIndex: 'pml',
            key: 'pml',
            width: 100,
        },{
            title: '合同额含税/人民币',
            dataIndex: 'jdeContractAmount',
            key: 'jdeContractAmount',
            width: 100,
        },{
            title: '服务费含税/人民币',
            dataIndex: 'cnyServiceFeeIncludeTax',
            key: 'cnyServiceFeeIncludeTax',
            width: 150,
            render: text => format('money', text),
        },{
            title: '当月是否新增补充合同',
            dataIndex: 'thisMonthHasSupplement',
            key: 'thisMonthHasSupplement',
            render: value => value==1?'是':value==0?'否':'',
            width: 80,
        },{
            title: '项目计划开始时间',
            dataIndex: 'investigationPlanBeginTime',
            key: 'investigationPlanBeginTime',
            width: 150,
        }, {
            title: '项目计划结束时间',
            dataIndex: 'investigationPlanEndTime',
            key: 'investigationPlanEndTime',
            width: 80,
        },{
            title: '津石计划随机（入组）数量',
            dataIndex: 'planRandomAmount',
            key: 'planRandomAmount',
            width: 100,
        },{
            title: '津石计划标准访视数',
            dataIndex: 'planVisitAmount',
            key: 'planVisitAmount',
            width: 100,
        },{
            title: '累计完成随机（入组）数',
            dataIndex: 'totalRandomAmount',
            key: 'totalRandomAmount',
            width: 100,
        },{
            title: '累计完成标准访视数',
            dataIndex: 'totalVisitAmount',
            key: 'totalVisitAmount',
            width: 100,
        },{
            title: '当月新增入组例数',
            dataIndex: 'thisMonthInGroupAmount',
            key: 'thisMonthInGroupAmount',
            width: 100,
        },{
            title: (
                <span>
                    启动比例
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'实际启动中心数/津石计划负责中心数量'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'siteStartPercent',
            key: 'siteStartPercent',
            width: 100,
        },{
            title: (
                <span>
                    标准访视数完成比例
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'累计完成标准访视数/津石计划标准访视数'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'visitAmountPercent',
            key: 'visitAmountPercent',
            width: 100,
        },{
            title: (
                <span>
                    截止当月服务费回款比例
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'费用类型为服务费的回款记录'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'thisMonthServiceFeeTotalPercent',
            key: 'thisMonthServiceFeeTotalPercent',
            width: 100,
        },{
            title: (
                <span>
                    截止上月服务费回款比例
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'费用类型为服务费的回款记录'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'lastMonthServiceFeeTotalPercent',
            key: 'lastMonthServiceFeeTotalPercent',
            width: 100,
        }, 
        {
            title: '截止本月POC%',
            dataIndex: 'poc',
            key: 'poc',
            width: 100,
        }, {
            title: '截止上月POC%',
            dataIndex: 'lastPoc',
            key: 'lastPoc',
            width: 100,
        }, {
            title: '本月完工%',
            dataIndex: 'completed',
            key: 'completed',
            width: 90,
        }, {
            title: '当月服务费收入不含税/人民币',
            dataIndex: 'cnyCurrentMonthIncomeNoTax',
            key: 'cnyCurrentMonthIncomeNoTax',
            width: 120,
        }];
        // const { curRole } = sessionStorage;
        // if (curRole == 'PM'||curRole=="PML") {
            columns.push({
                title: '操作',
                dataIndex: 'option',
                key: 'option',
                fixed: 'right',
                width: 120,
                render: (text, record, index) => {
                   const {searchParams,
                   nowDate
                   }= this.state;
                   const { date } = searchParams;
                   //const nowDate = "2021-11-28 12:25:26";
                   const nowM = moment(nowDate).format('YYYY-MM');
                   const nowT = moment(nowDate).format('YYYY-MM-DD HH:mm');
                   const canMark = (nowM==date && ( `${nowM}-28 12:00` < nowT ) && ( nowT < `${nowM}-29 24:00`));
                        return (
                                <span>
                                    <a onClick={() => this.markNormal(record)} disabled={!canMark}>标记为正常项目</a>
                                </span>
                        );
                },
            });
        // }
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { exportable } = this.props;
        const { data, loading, pagination, searchParams, sortParams } = this.state;
        return (
            <div className="FinancialAnomalyReportContent">
                <div className='modTitle'>服务费收入异常报告</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    export={this.export}
                />
                <TableC
                    data={data}
                    loading={loading}
                    className="FinancialAnomalyReport"
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
                <RemarkNormalModal ref={el => this.remarkNormalModalRef = el}  reload={this.loadData}/>
            </div>
        );
    }
}

export default FinancialAnomalyReport;


// WEBPACK FOOTER //
// ./src/components/homePage/myFocus/FinancialAnomalyReport.js